export const FACING_MODE_ENVIRONMENT = 'environment'
